/* eslint-disable react/no-array-index-key */
import React, { useEffect } from 'react'
import { useDispatch, connect } from 'react-redux'
import styled from 'styled-components'

// libs
import { filtroProvincia, makeFichaAvisoURL } from '@navent-jobs/interlinking'

// ui-kit
import { Pagination } from '@navent-jobs/ui-kit/components/pagination'

// components
import Card from '../../../../components/card'
import CardPlaceholder from '../card/CardPlaceholder'

// mixins
import { makeListadoAvisoCard } from './mixins'

// constants
import { DataLayers as PageDataLayers } from '../../../../constants/gtm-events-listado-page'

// reedux
import { getAvisos } from '../../../../redux/actions/listado-avisos'
import { getSettingsSort } from '../../../../redux/actions/sort'
import { userLoggedIn } from '../../../../utils/cookies'

const CONFIDENCIAL = 'Confidencial'
const TOTAL_CARDS_PLACEHOLDER = 20

const ListadoAvisoCard = styled(Card)`
  ${() => makeListadoAvisoCard()}
`

const ListadoAvisosBis = ({ activeAviso, avisos, filtersApplied, pagination, loading, error, parentRoute }) => {
  const queryParams = new URLSearchParams(parentRoute.location.search)
  const dispatch = useDispatch()

  const loadPage = page => {
    dispatch(
      getAvisos({
        sortParams: queryParams,
        filtros: [...filtroProvincia(parentRoute.match.params)],
        page,
        ...parentRoute.match,
      })
    )
  }

  const onClickAviso = (event, url) => {
    if (!(event.ctrlKey || event.metaKey)) {
      event.preventDefault()
      window.open(url, '_blank')
    }
  }

  useEffect(() => {
    dispatch(getSettingsSort())
  })

  useEffect(() => {
    PageDataLayers.onload(filtersApplied, 'Listado', userLoggedIn())
  }, [filtersApplied])

  useEffect(() => {
    if (avisos && document.documentElement.scrollTo) {
      document.documentElement.scrollTo(0, 0)
    }
  }, [avisos, document])

  useEffect(() => {
    loadPage(0)
  }, [parentRoute.match.url, parentRoute.location.search])

  if (error) {
    return null
  }

  return (
    <>
      {loading &&
        [...Array(TOTAL_CARDS_PLACEHOLDER)].map((e, i) => {
          return <CardPlaceholder key={i} />
        })}

      {avisos &&
        avisos.map((aviso, index) => {
          return (
            <ListadoAvisoCard
              key={aviso.id}
              aviso={aviso}
              disableLink={false}
              activeAvisoId={activeAviso && activeAviso.activeAvisoId}
              index={index}
              ubicacion="Listado"
              onClick={({ event }) =>
                onClickAviso(
                  event,
                  makeFichaAvisoURL({
                    ...aviso,
                    empresa: { denominacion: aviso.empresa, confidencial: aviso.empresa === CONFIDENCIAL },
                  })
                )
              }
              link={makeFichaAvisoURL({
                ...aviso,
                empresa: { denominacion: aviso.empresa, confidencial: aviso.empresa === CONFIDENCIAL },
              })}
            />
          )
        })}

      <Pagination {...pagination} states={{ loading }} goToPage={loadPage} />
    </>
  )
}

const states = ({ listadoAvisosStore, filtersStore, activeAvisoStore }) => ({
  activeAviso: activeAvisoStore,
  filtersApplied: filtersStore.filtersApplied,
  avisos: listadoAvisosStore.avisos,
  pagination: listadoAvisosStore.pagination,
  loading: listadoAvisosStore.loading,
  error: listadoAvisosStore.error,
})

export default connect(states)(ListadoAvisosBis)
